export enum DraftJobChangesSyncState {
  SCANNING = 'SCANNING',
  CHANGES_READY = 'CHANGES_READY',
  APPLYING = 'APPLYING',
  SYNCED = 'SYNCED',
  FAILED = 'FAILED'
}
